import { render, staticRenderFns } from "./SelectCatalogsView.vue?vue&type=template&id=3eccdcef"
import script from "./SelectCatalogsView.vue?vue&type=script&lang=js"
export * from "./SelectCatalogsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports